var $95c76e6a3ff4645c$exports = {};
$95c76e6a3ff4645c$exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `A carregar...`,
    "noResults": `Sem resultados`,
    "valid": `(v\xe1lido)`
};


export {$95c76e6a3ff4645c$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
